if (!window.Eurus.loadedScript.includes('rr-appier-recommendations.js')) {
    window.Eurus.loadedScript.push('rr-appier-recommendations.js');
  
    requestAnimationFrame(() => {
        document.addEventListener("alpine:init", () => {
            Alpine.data("xAppierRecommendations", () => ({
                recommendations: [],
                loading: true,
                currency: window.ShopCurrency,
        
                fetchRecommendations(scenario) {
                    const product_id = document.querySelector('input[name="product-id"]').value;
        
                    appier(
                        "getRecommendationByScenario",
                        {
                            scenarioId: scenario,
                            productId: product_id || '',
                            filter: {
                                version: 2,
                                filterRule: {
                                    operator: "OR",
                                    ruleList: [
                                        {
                                            operator: "AND",
                                            conditionList: []
                                        }
                                    ]
                                }
                            },
                            num: 10
                        },
                        (err, RecommendationData) => {
                            if (err) {
                                console.error("Appier Recommendation Error:", err);
                                this.loading = false;
                                return;
                            }
                            this.recommendations = RecommendationData.map(product => ({
                                id: product.productId,
                                title: product.title,
                                url: product.url,
                                featured_media: product.image,
                                price: product.price,
                                vendor: product.customLabel00,
                                compare_at_price: product.originalPrice ? product.originalPrice : null
                            }));
                            
                            this.loading = false;
                        },
                    );
                },
            }));
        });
    });
}